<template>
  <section class="home-app">
    <b-container>
      <b-row class="align-items-center">
        <b-col md="7" class="home-app__text">
          <h2 class="home-app__heading">{{ $t('pages.home.app.title') }}</h2>
          <p class="text-muted mb-0">{{ $t('pages.home.app.text') }}</p>
        </b-col>
        <b-col md="5" class="home-app__badges">
          <app-store-badges />
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  import AppStoreBadges from '@base/components/AppStoreBadges.vue'

  export default {
    name: 'HomeAppBand',

    components: {
      AppStoreBadges,
    },
  }
</script>

<style scoped>
  .home-app {
    background: var(--ui-surface);
    padding: 2.5rem 0;
  }

  .home-app__text {
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .home-app__heading {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--ui-ink);
    margin-bottom: 0.5rem;
  }

  .home-app__badges {
    display: flex;
    justify-content: center;
  }

  @media (min-width: 768px) {
    .home-app__text {
      text-align: left;
      margin-bottom: 0;
    }

    .home-app__badges {
      justify-content: flex-end;
    }
  }
</style>
